import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=0b960746&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b960746')) {
      api.createRecord('0b960746', component.options)
    } else {
      api.reload('0b960746', component.options)
    }
    module.hot.accept("./DeviceDetail.vue?vue&type=template&id=0b960746&", function () {
      api.rerender('0b960746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicedetail/DeviceDetail.vue"
export default component.exports